module.exports = __webpack_public_path__ + "img/andy_williams.15d60069.jpeg";